//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { openAngularModal } from '@react-bridge/wrappers/modal';

// TODO: PD-245055 - modernize and add appropriate types.

const DEFAULT_TITLE = "Nuts! That didn't work...";

export function showErrorDialog(title, message, errorId, size) {
  size = size || 'small';

  return openAngularModal({
    template:
      '<confirmation-modal ' +
      'close="$close(result)" ' +
      'confirm-text="\'Ok\'" ' +
      'modal-title="modalTitle" ' +
      'submit-action="angular.noop" ' +
      'hide-cancel-button="true"' +
      '>' +
      '<p ng-bind-html="message"></p>' +
      '<p ng-if="errorId" ng-bind-html="errorId"></p>' +
      '</confirmation-modal>',
    windowClass: `pure-bs3 confirmation-modal-container modal-${size}`,
    controller: [
      '$sce',
      '$scope',
      'message',
      'title',
      'errorId',
      ($sce, $scope, message, title, errorId) => {
        $scope.modalTitle = title;
        $scope.message = $sce.trustAsHtml(message);
        if (typeof errorId !== 'undefined' && errorId !== null) {
          $scope.errorId = $sce.trustAsHtml(`Error Id: ${errorId}`);
        }
      },
    ],
    resolve: {
      message() {
        return message;
      },
      title() {
        return title;
      },
      errorId() {
        return errorId;
      },
    },
  });
}

export function showDefaultErrorDialog(message, error?) {
  const errorId = typeof error === 'object' ? error.errorId : error;
  this.showErrorDialog(DEFAULT_TITLE, message, errorId);
}

export function showTrackLimitErrorDialog(error) {
  const errorComponents = error.split('::');
  const sourceType = errorComponents[1];
  const errorNumber = errorComponents[2];
  const errorMessage =
    `Uh oh! You've hit your limit of ${errorNumber} tracked ${sourceType}s.<br><br>` +
    `You can manage your tracked ${sourceType}s in your ` +
    `<a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
  this.showErrorDialog('Track Limit Reached', errorMessage);
}

export function showCollectionTrackLimitErrorDialog(error) {
  const errorComponents = error.split('::');
  const sourceType = errorComponents[1];
  const errorNumber = errorComponents[2];
  const errorMessage =
    `Uh oh! We were unable to add this ${sourceType} to your Collection because ` +
    `you have hit your limit of ${errorNumber} tracked ${sourceType}s.<br><br>` +
    `You can manage your tracked ${sourceType}s in your ` +
    `<a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
  this.showErrorDialog('Track Limit Reached', errorMessage);
}

export function showNewCollectionTrackLimitErrorDialog(error) {
  const errorComponents = error.split('::');
  const sourceType = errorComponents[1];
  const errorNumber = errorComponents[2];
  const errorMessage =
    `Uh oh! We were unable to add this ${sourceType} to a ` +
    `new Collection because you have hit your limit of ${errorNumber} ` +
    `tracked ${sourceType}s.<br><br>` +
    `You can manage your tracked ${sourceType}s in your ` +
    `<a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
  this.showErrorDialog('Track Limit Reached', errorMessage);
}

export function showListTrackLimitErrorDialog(error) {
  let sourceType;
  let errorNumber;
  if (error.startsWith('maxusers')) {
    sourceType = 'user';
    errorNumber = error.split(':')[1];
  } else {
    sourceType = error.split('::')[1];
    errorNumber = error.split('::')[2];
  }
  const errorMessage =
    `Uh oh! We were unable to add this user to your ` +
    `Influencer List because you have hit your limit of ${errorNumber} ` +
    `tracked users.<br><br>` +
    `You can manage your tracked ${sourceType}s in your ` +
    `<a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
  this.showErrorDialog('Track Limit Reached', errorMessage);
}

export function showNewListTrackLimitErrorDialog(error) {
  const errorComponents = error.split('::');
  const sourceType = errorComponents[1];
  const errorNumber = errorComponents[2];
  const errorMessage =
    `Uh oh! We were unable to add this user to a new Influencer List ` +
    `because you have hit your limit of ${errorNumber} tracked users.<br><br>` +
    `You can manage your tracked ${sourceType}s in your ` +
    `<a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
  this.showErrorDialog('Track Limit Reached', errorMessage);
}
